(() => {
  function parseDate(value) {
    if (!value) return null;
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return null;
    return d;
  }

  function formatFromDiff(template, diffMs) {
    const totalSeconds = Math.max(0, Math.floor(diffMs / 1000));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    return template
      .replace(/\[days\]/g, String(days))
      .replace(/\[hours\]/g, String(hours))
      .replace(/\[minutes\]/g, String(minutes));
  }

  function initTimerElement(el) {
    const template = el.getAttribute('data-timer-template');
    const startStr = el.getAttribute('data-timer-start');
    const endStr = el.getAttribute('data-timer-end');

    if (!template || !endStr) return;

    // The Liquid update ensures these strings now look like: "2025-09-24T00:00:00-0500"
    // reliable cross-browser parsing:
    const startDate = startStr ? new Date(startStr) : null;
    const endDate = new Date(endStr);
    
    if (isNaN(endDate.getTime())) return; // Safety check

    let intervalId = null;

    function tick() {
      const now = new Date(); // This gets user's current time

      // Comparison works now because endDate is absolute (Store Time) 
      // and now is absolute (User Time converted to Unix Epoch internally)
      if (startDate && now < startDate) {
        el.textContent = '';
        el.classList.add('timer--hidden'); // Ensure hidden class is added back if needed
        return;
      }

      const diff = endDate.getTime() - now.getTime();

      if (diff <= 0) {
        el.textContent = '';
        el.classList.add('timer--hidden'); // Hide when done
        if (intervalId) {
          clearInterval(intervalId);
        }
        return;
      }

      el.textContent = formatFromDiff(template, diff);
      el.classList.remove('timer--hidden');
    }

    tick();
    intervalId = window.setInterval(tick, 1000); // Recommend 1000ms (1s) instead of 60000 to prevent visual lag
  }

  function initAllTimers(root) {
    const scope = root || document;
    const timers = scope.querySelectorAll('[data-timer-template]');
    timers.forEach(initTimerElement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllTimers());
  } else {
    initAllTimers();
  }

  // Expose for sections re-rendered via AJAX / theme editor
  window.FHTimersInit = initAllTimers;
})();